<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-address-card card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div ref="displayStatHtml"></div>

      <div class="card-data-media" v-if="node.data.genericTemplateTitle">
        <div class="typing_delay clearfix mb-2 p-1 pl-3 pr-3" v-if="node.data.IsTypingOnDisplayChecked">
          <p class="typing_display float-left mb-0 p-0">
            <img :src="baseUrl + 'assets/pre-loader/typing_on.gif'" height="9px" width="20px"> {{ typing_display }}
          </p>
          <p class="delay_time float-right mb-0" v-if="node.data.delayReplyFor">
            {{ node.data.delayReplyFor }} {{ sec }}
          </p>
        </div>

        <div class="card mb-2" v-if="node.data.file">
          <img class="card-img-top" :src="node.data.file"/>
          <div class="card-body p-2">
            <h5 class="card-title mb-0" v-if="node.data.genericTemplateTitle">{{ node.data.genericTemplateTitle }}</h5>
            <p class="card-text text-muted mt-0 mb-2" v-if="node.data.genericTemplateSubtitle">{{ node.data.genericTemplateSubtitle }}</p>
            <a :href="node.data.imageClickDestinationLink" class="btn btn-sm btn-outline-primary card-image-link" v-if="node.data.imageClickDestinationLink">{{ node.data.imageClickDestinationLink }}</a>
          </div>
        </div>

      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods, updateNodeConnections } from '../../functions/utils'

export default {
  name: 'GenericTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,
  }),

  methods: {
    ...templateComponentMethods,  
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>

<style scoped>
.content-title { 
  margin-bottom: 0px;
  font-weight: 500;
  margin-top: -5px;
}
.content-subtitle {
  margin-bottom: 5px;
  margin-top: -7px;
  color: #a9a7a7;
}
.input_content { width:50% !important;margin-top: 52px;}
.output_content{ width:50% !important;float:right !important;}
.card-sockets { padding: 3px 0 !important;}
.card-data-media { font-size: 14px; }
.xit-fb-template.hasData { min-width: 250px !important; }
</style>